import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Table } from 'reactstrap';
import { TextFormat, Translate, getSortState } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { APP_DATE_FORMAT } from 'app/config/constants';
import { ASC, DESC } from 'app/shared/util/pagination.constants';
import { overrideSortStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities } from './dynamic-tariff.reducer';

export const DynamicTariff = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [sortState, setSortState] = useState(
    overrideSortStateWithQueryParams(getSortState(pageLocation, 'id'), pageLocation.search),
  );

  const dynamicTariffList = useAppSelector(state => state.dynamicTariff.entities);
  const loading = useAppSelector(state => state.dynamicTariff.loading);

  const getAllEntities = () => {
    dispatch(
      getEntities({
        sort: `${sortState.sort},${sortState.order}`,
      }),
    );
  };

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?sort=${sortState.sort},${sortState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [sortState.order, sortState.sort]);

  const sort = p => () => {
    setSortState({
      ...sortState,
      order: sortState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = sortState.sort;
    const order = sortState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="dynamic-tariff-heading" data-cy="DynamicTariffHeading">
        <Translate contentKey="crawlerBackendApp.dynamicTariff.home.title">Dynamic Tariffs</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="crawlerBackendApp.dynamicTariff.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/dynamic-tariff/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="crawlerBackendApp.dynamicTariff.home.createLabel">
              Create new Dynamic Tariff
            </Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {dynamicTariffList && dynamicTariffList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="crawlerBackendApp.dynamicTariff.id">ID</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('price')}>
                  <Translate contentKey="crawlerBackendApp.dynamicTariff.price">Price</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('price')} />
                </th>
                <th className="hand" onClick={sort('from')}>
                  <Translate contentKey="crawlerBackendApp.dynamicTariff.from">From</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('from')} />
                </th>
                <th className="hand" onClick={sort('until')}>
                  <Translate contentKey="crawlerBackendApp.dynamicTariff.until">Until</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('until')} />
                </th>
                <th className="hand" onClick={sort('productType')}>
                  <Translate contentKey="crawlerBackendApp.dynamicTariff.productType">Product Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('productType')} />
                </th>
                <th className="hand" onClick={sort('unit')}>
                  <Translate contentKey="crawlerBackendApp.dynamicTariff.unit">Unit</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('unit')} />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {dynamicTariffList.map((dynamicTariff, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/dynamic-tariff/${dynamicTariff.id}`} color="link" size="sm">
                      {dynamicTariff.id}
                    </Button>
                  </td>
                  <td>{dynamicTariff.price}</td>
                  <td>
                    {dynamicTariff.from ? (
                      <TextFormat type="date" value={dynamicTariff.from} format={APP_DATE_FORMAT} />
                    ) : null}
                  </td>
                  <td>
                    {dynamicTariff.until ? (
                      <TextFormat type="date" value={dynamicTariff.until} format={APP_DATE_FORMAT} />
                    ) : null}
                  </td>
                  <td>
                    <Translate contentKey={`crawlerBackendApp.ProductType.${dynamicTariff.productType}`} />
                  </td>
                  <td>
                    <Translate contentKey={`crawlerBackendApp.UnitType.${dynamicTariff.unit}`} />
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/dynamic-tariff/${dynamicTariff.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/dynamic-tariff/${dynamicTariff.id}/edit`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() => (window.location.href = `/dynamic-tariff/${dynamicTariff.id}/delete`)}
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="crawlerBackendApp.dynamicTariff.home.notFound">No Dynamic Tariffs found</Translate>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default DynamicTariff;
